import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { srOnly } from '../styles/composables.css.js';

/**
 * Visually hides the children content, but
 * makes it still available for a screen reader user
 */
const ScreenReaderOnly = forwardRef(({ as, ...props }, ref) => {
    const Component = (as || 'div');
    // eslint-disable-next-line fpl/fpl-data-attr -- hidden
    return jsx(Component, { ...props, ref: ref, className: srOnly, "data-fpl-sr-only": true });
});
ScreenReaderOnly.displayName = 'ScreenReaderOnly';

export { ScreenReaderOnly };
//# sourceMappingURL=sr-only.js.map
